import * as React from 'react';
import { magazine } from '../../../../helpers/routes';
import RegionalContent from './RegionalContent';

const mainText =
  'italist是全世界最大的與意大利奢侈品牌精品店直接合作的頂級時尚電商。作為行業的創新典範，我們將重新打造獨一無二的意大利奢侈精品購物體驗。\
  我們不但以極具優勢的價格(低於市場均價30%以上)提供精緻前沿的意大利時尚，同時也讓您有機會找到其他網站上無法找到的當季獨特產品！本站保證\
  您所購買的所有商品都是全新的正品，直接從意大利寄送至中國大陸及香港地區。';
const actionHref = `${magazine}how-to-buy-on-italist-chinese/`;
const actionText = '了解更多资讯，请点击中文购物指南';

export default () => <RegionalContent mainText={mainText} actionText={actionText} actionHref={actionHref} />;
